import { render, staticRenderFns } from "./comments_list.vue?vue&type=template&id=a44abe3e&scoped=true"
import script from "./comments_list.vue?vue&type=script&lang=js"
export * from "./comments_list.vue?vue&type=script&lang=js"
import style0 from "./comments_list.vue?vue&type=style&index=0&id=a44abe3e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a44abe3e",
  null
  
)

export default component.exports